import { cn } from "@utils/tw"
import { ComponentProps, ReactNode } from "react"

type Props = ComponentProps<"div"> & { label: ReactNode }

export function ItemGroup({ label, className, children, ...props }: Props) {
  return (
    <div
      {...props}
      className={cn(
        "item-group w-full flex flex-col py-3 gap-3 border-t border-b border-blue [&_+_.item-group]:border-t-0",
        className,
      )}
    >
      <p className="type-label-s">{label}</p>
      <div>{children}</div>
    </div>
  )
}
